import {connect} from 'react-redux';
import MenuComponent from '../../Components/Layouts/responsiveMenu';
import {userLogOut} from '../../redux/actions/AuthActions';
import {resetMerchantDetails} from '../../redux/actions/MerchantActions';

const ResponsiveMenuContainer = connect (
    (state) => {
        return {
            user: state.authReducer
        };
    },
    (dispatch) => {
        return {
            userLogOut: () => {
                dispatch(userLogOut());
            },
            resetMerchantDetails: () => {
                dispatch(resetMerchantDetails());
            },
        };
    }
)(MenuComponent);

export default ResponsiveMenuContainer;